import { Button } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import ActiveIntegrationIcon from '@nile/client_management/src/Components/ActiveInvoiceBillingIntegrationIcon';
import React, { useState } from 'react';
import dompurify from 'dompurify';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';
import { dompurifier } from '@nile/components/src/Utils/helpers';

/**
 * Cells are specific to the components using the table.
 * This action cell is used to push the invoice to third party.
 */

const integrationMap = {
  QUICK_BOOKS_DESKTOP: {
    push: 'invoice.actions.pushToQuickbooksDesktop',
    repush: 'invoice.actions.pushToQuickbooksDesktop',
    send: 'invoice.actions.sendInvoice',
    resend: 'invoice.actions.resendInvoice'
  },
  QUICK_BOOKS_ONLINE: {
    push: 'invoice.actions.pushToQuickbooks',
    repush: 'invoice.actions.repushToQuickbooks',
    send: 'invoice.actions.sendInvoice',
    resend: 'invoice.actions.resendInvoice'
  },
  XERO: {
    push: 'invoice.actions.pushToXero',
    repush: 'invoice.actions.repushToXero',
    send: 'invoice.actions.sendInvoice',
    resend: 'invoice.actions.resendInvoice'
  },
  DEFAULT: {
    send: 'invoice.actions.sendInvoice',
    resend: 'invoice.actions.resendInvoice'
  }
};

function ActionCell(props) {
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const [actionLoading, setActionLoading] = useState(false);
  const { actions, integrationType = 'DEFAULT' } = cell.column;

  const pushedToAppLoading = meta?.pushedToIntegratedAppStatus === 'PROGRESS';

  const { loadingState } = cell;
  const pushActionKey =
    meta.pushedToIntegratedAppStatus !== null ||
    (meta.statusEnum === 'PAID' &&
      (!meta.pushPaymentToIntegratedAppStatus ||
        meta.pushPaymentToIntegratedAppStatus === 'FAILURE'))
      ? 'repush'
      : 'push';
  const sendActionKey = meta.sentToClient ? 'resend' : 'send';
  const renderActions = () => {
    switch (cell?.column?.id) {
      case 'pushToThirdParty':
        return (
          <div className="flex actr">
            <ActiveIntegrationIcon
              integrationId={integrationType}
              height="19px"
              width="19px"
            />
            <span className="ml-5">
              <FormattedMessage
                id={integrationMap[integrationType][pushActionKey]}
              />
            </span>
          </div>
        );
      case 'sendInvoice':
        return (
          <div className="flex actr">
            <SVGIcon name="InvoiceLogo" />
            <span className="ml-5">
              <FormattedMessage
                id={integrationMap[integrationType][sendActionKey]}
              />
            </span>
          </div>
        );
      default:
        return '';
    }
  };
  return (
    <div className="action-button flex center g20">
      {loadingState ? (
        <Tooltip
          html={
            <p
              dangerouslySetInnerHTML={{
                __html: dompurifier(
                  getTranslatedText(
                    intl,
                    'client.details.invoice.pushToThirdParty.loading'
                  )
                )
              }}
            />
          }
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
          className="tooltip"
        >
          <Button
            loading={actionLoading || loadingState || pushedToAppLoading}
            onClick={() => {
              actions.onClick(meta, integrationType, setActionLoading);
              setActionLoading(true);
            }}
          >
            {renderActions()}
          </Button>
        </Tooltip>
      ) : (
        <Button
          loading={actionLoading || loadingState || pushedToAppLoading}
          onClick={() => {
            actions.onClick(meta, integrationType, setActionLoading);
            setActionLoading(true);
          }}
        >
          {renderActions()}
        </Button>
      )}
    </div>
  );
}

export default injectIntl(ActionCell);
